import "@skv/frontend/src/styles/main-nsw.scss";

import "core-js/stable";
import "regenerator-runtime";

import smoothscroll from "smoothscroll-polyfill";

import * as React from "react";
import * as ReactDOM from "react-dom";
import Root from "./Root";

smoothscroll.polyfill();

declare const global: {
  React: typeof React;
  ReactDOM: typeof ReactDOM;
  Root: typeof Root;
};

global.React = React;
global.ReactDOM = ReactDOM;

global.Root = Root;
